import type { ReactNode } from "react";

interface EmptyTabStateProps {
  icon: ReactNode;
  title: string;
  description: string;
  action?: ReactNode;
}

export function EmptyTabState({ icon, title, description, action }: EmptyTabStateProps) {
  return (
    <div className="flex flex-1 items-center justify-center p-6">
      <div className="flex flex-col items-center">
        <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-muted">
          {icon}
        </div>
        <p className="text-center text-sm font-medium text-muted-foreground">{title}</p>
        <p className="mt-1 text-center text-xs text-muted-foreground/70">{description}</p>
        {!!action && action}
      </div>
    </div>
  );
}
